export default __webpack_public_path__ + "static/media/P10001.406f9577.png";